<!-- Unlike a Button Container, a Button Template Container has template slots -->
<div
  class="button-template-layout"
  [style.flex-direction]="layoutState().direction"
  [style.justify-content]="layoutState().justifyContent"
  [style.align-items]="layoutState().alignItems"
>
  <ng-content />
</div>
